import { patient } from './patient.query';
import { user } from './user.query';

export const pii = { patient, user };
